/**
 * The elements/tags to render the embed into are divs with the attribute `data-burgerbegroting-ranking`.
 */
export const TARGET_SELECTOR = "[data-burgerbegroting-ranking]";

/**
 * Every container in `root`, including `root` itself when it is one:
 * `querySelectorAll` only looks at descendants, while a DOM mutation hands us
 * the inserted or removed node itself.
 *
 * @param {Element} root
 * @returns {Element[]}
 */
export function findTargets(root) {
  return [
    ...(root.matches(TARGET_SELECTOR) ? [root] : []),
    ...root.querySelectorAll(TARGET_SELECTOR),
  ];
}
